import React from 'react';

import { Block } from '@klp/design';
import { useKlpStyles } from '@klp/design/Theme';

const styles = () => ({
    title: {
        textTransform: 'uppercase' as const,
    },
});

export const ContractManagementSummary: React.FC = () => {
    const classes = useKlpStyles({}, styles);

    return (
        <Block
            marginTop="compact"
            klpTypographyVariant="xsmall"
            className={classes.title}
            translation="frontPage.contractManagement.subtitle"
        />
    );
};
